import isArray from 'lodash/isArray'

export default (input, start, end) => {
  if (!input || !input.length) return input
  if (start < 0) start += input.length
  if (end < 0) end += input.length
  if (typeof input === 'string') return start >= end ? '' : input.substring(start, end)
  if (isArray(input)) return start >= end ? [] : input.slice(start, end)
  return input
}



// WEBPACK FOOTER //
// ./src/utils/sub.js